// The privacy field accepts a bare http(s) URL (legacy values) or a markdown
// sentence with an embedded link (NOR-349). These helpers normalize both.

const BARE_URL_RE = /^https?:\/\/\S+$/;
const MD_LINK_HREF_RE = /\]\((https?:\/\/[^)\s]+)\)/;

// Default sentence around the privacy link. Also used to pre-fill the
// Einstellungen field (with a placeholder URL the admin replaces).
export const PRIVACY_SENTENCE = (url) =>
  `Weitere Informationen zum Schutz Ihrer personenbezogenen Daten finden Sie in unserer [Datenschutzerklärung](${url}).`;

export const PRIVACY_URL_PLACEHOLDER = 'https://...';

// Markdown to render as the privacy chat bubble; '' when unconfigured.
export function privacyMarkdown(value) {
  const trimmed = (value || '').trim();
  if (!trimmed) return '';
  if (BARE_URL_RE.test(trimmed)) {
    return PRIVACY_SENTENCE(trimmed);
  }
  return trimmed;
}

// Plain href for standalone links (chat footer, embed header); '' when none.
export function privacyHref(value) {
  const trimmed = (value || '').trim();
  if (!trimmed) return '';
  if (BARE_URL_RE.test(trimmed)) return trimmed;
  const match = trimmed.match(MD_LINK_HREF_RE);
  return match ? match[1] : '';
}
